import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import quagga from 'quagga'

let instance

export const getInstance = () => instance

export const useQuagga = ({
	...options
}) => {
	if (instance) return instance

	instance = new Vue({
		data () {
			return {
				isAvailable: false,
				isInit: false,
				detectedCode: null,
				scanAreaWidth: 0,
				scanAreaHeight: 0
			}
		},
		computed: {
			// getters
			...mapGetters({
				$_productsList: 'Product/getProductsList',
				$_scannedBarcode: 'Product/getScannedBarcode'
			})
		},
		created () {
			// 利用可能かチェック
			this.isAvailable = this.checkAvailability()
		},
		methods: {
			// dispatch
			...mapActions({
				productVuex_pushScannedBarcode: 'Product/pushScannedBarcode'
			}),
			/**
			 * メディアデバイスのストリームの利用が可能か確認
			 */
			checkAvailability () {
				if (
					navigator.mediaDevices &&
					typeof navigator.mediaDevices.getUserMedia === 'function'
				) {
					// safely access `navigator.mediaDevices.getUserMedia`
					return true
				}
				return false
			},
			/**
			 * 初期化する
			 * @param {String} targetId マウントする要素のIDを指定
			 * @param {Boolean} isAndroid Androidかどうかのフラグ
			 * @see {link https://github.com/serratus/quaggaJS#quaggainitconfig-callback | quaggaJS}
			 */
			async init (targetId, isAndroid) {
				const selected = await this.getDiviceId(isAndroid)
				if (selected !== null) {
					options.config.inputStream.constraints.deviceId = selected.deviceId
				}
				const deferred = new Promise((resolve, reject) => {
					if (!this.isAvailable) {
						return reject(new Error('お使いのブラウザではカメラの機能が使えません'))
					}

					this.isInit = false
					const sw = window.screen.width
					const config = _.cloneDeep(options.config)
					this.scanAreaWidth = sw// window.screen.width
					// 横幅基準で黄金比に揃える
					this.scanAreaHeight = sw// Math.round(window.screen.width / 1.6)
					const target = document.querySelector(targetId)
					const cbFunction = err => {
						if (err) {
							return reject(new Error('カメラの利用が許可されていません'))
						}

						this.isInit = true
						this.start()
						return resolve()
					}

					config.inputStream.target = target
					config.inputStream.constraints.width = this.scanAreaWidth
					config.inputStream.constraints.height = this.scanAreaHeight
					quagga.onProcessed(result => {
						this.processed(result)
					})
					quagga.onDetected(result => {
						this.detected(result)
					})
					quagga.init(
						config,
						cbFunction
					)
				})
				return deferred
			},
			/**
			 * 端末のカメラ情報を取得してくる
			 * @return  {[Array]}  [デバイス情報の配列]
			 */
			initCameraSelection () {
				return quagga.CameraAccess.enumerateVideoDevices()
			},
			async getDiviceId (isAndroid) {
				let selected = null
				// androidのときのみデバイスIDを取得する
				if (!isAndroid) return selected
				// 現状どのカメラが良いのか判別不可能なので一番最後のカメラを指定
				const devices = await this.initCameraSelection()
				_.forEach(devices, device => {
					if (device.kind === 'videoinput') {
						// labelの文字例 = 'camera2 0, facing back'
						if (device.label.indexOf('back') > 0) {
							selected = device
						}
					}
				})
				return selected
			},
			/**
			 * 検出中の処理を行う
			 * @return {Object} result ストリームデータ
			 * @see {link https://github.com/serratus/quaggaJS#quaggaonprocessedcallback | quaggaJS}
			 * @see {link https://github.com/serratus/quaggaJS#the-result-object | quaggaJS}
			 */
			processed (result) {
				const ctx = quagga.canvas.ctx.overlay
				const canvas = quagga.canvas.dom.overlay
				if (!result) return
				// 検出してまだ読み取っていないバーコードを緑の枠で囲む
				if (result.boxes) {
					ctx.clearRect(0, 0, canvas.width, canvas.height)
				}
				// 検出して読み取ったバーコードを青の枠で囲む
				if (result.box) {
					quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, ctx, {
						color: 'blue',
						lineWidth: 2
					})
				}

				// 検出済みのバーコードに赤い線を引く
				if (
					result.codeResult &&
					result.codeResult.code
				) {
					quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, ctx, {
						color: 'red',
						lineWidth: 3
					})
				}
			},
			/**
			 * 検出時の処理を行う
			 * @return {Object} result ストリームデータ
			 * @see {link https://github.com/serratus/quaggaJS#quaggaondetectedcallback | quaggaJS}
			 * @see {link https://github.com/serratus/quaggaJS#the-result-object | quaggaJS}
			 */
			detected (result) {
				const code = result.codeResult.code
				let isAlreadyScanned = false

				this.detectedCode = code

				// すでに読み込んだ商品か確認
				_.forEach(this.$_scannedBarcode, item => {
					if (item.jan === code) {
						isAlreadyScanned = true
					}
				})

				if (isAlreadyScanned) return

				// 扱っている商品か確認
				const matchedItem = _.find(this.$_productsList, (o) => {
					return o.jan === code
				})

				if (matchedItem) {
					const newItem = _.cloneDeep(matchedItem)
					newItem.quantity = 1
					this.productVuex_pushScannedBarcode(newItem)
				} else {
					// eslint-disable-next-line
					console.log('該当商品無し')
				}
			},
			/**
			 * 読み取り開始
			 */
			start () {
				if (this.isInit) {
					quagga.start()
					this.drawScanFrame()
				}
			},
			/**
			 * 読み取り終了
			 */
			stop () {
				if (this.isInit) {
					quagga.stop()
				}
			},
			/**
			 * スキャン領域にフレームを描画
			 *
			 * @return  {[type]}  [return description]
			 */
			drawScanFrame () {
				const canvasDom = document.querySelector('#cameraFrame')
				const ctx = canvasDom.getContext('2d')

				const sw = this.scanAreaWidth
				// 現状は高さは横幅と同じに設定している
				const sh = this.scanAreaHeight
				// 描画ラインの長さ
				const side = 10
				// キャンバスの縦横がデフォルトサイズになっているので調整
				canvasDom.width = sw
				canvasDom.height = sh
				const cw = canvasDom.width
				const ch = canvasDom.height
				canvasDom.style.width = `${cw}px`
				canvasDom.style.height = `${ch}px`
				// 線の色と太さはキャンバスの縦横を変えた後に設定しないと反映されない
				// 描画カラー
				ctx.strokeStyle = '#dcbc00'
				// 描画ラインの太さ
				const lineWidth = 5
				ctx.lineWidth = lineWidth
				// フレームの縦幅 原則この値を変えたらフレームサイズが変わります (横幅は1.6倍)
				const frameHeight = 130
				// フレームの横幅
				const frameWidth = Math.round(frameHeight * 1.6)
				// 左上の描画座標
				const beginPos = {
					x: Math.round((cw - frameWidth) / 2),
					y: Math.round((ch - frameHeight) / 2)
				}
				const drawLine = (posFrom, posTo) => {
					ctx.moveTo(posFrom.x, posFrom.y)
					ctx.lineTo(posTo.x, posTo.y)
					ctx.closePath()
					ctx.stroke()
				}
				/**
				 * 配列の0番目は縦線を描画
				 * 配列の1番目は横線を描画
				 * 例 leftTop[0] の中身は縦線の始点と終点の座標
				 */
				// 左上
				const leftTop = [
					[
						beginPos,
						{
							x: beginPos.x,
							y: beginPos.y + side
						}
					],
					[
						{
							x: beginPos.x - (lineWidth / 2),
							y: beginPos.y
						},
						{
							x: beginPos.x + (lineWidth * 2),
							y: beginPos.y
						}
					]
				]
				// 左下
				const leftBottom = [
					[
						{
							x: beginPos.x,
							y: beginPos.y + frameHeight
						},
						{
							x: beginPos.x,
							y: beginPos.y + frameHeight - side
						}
					],
					[
						{
							x: beginPos.x - (lineWidth / 2),
							y: beginPos.y + frameHeight
						},
						{
							x: beginPos.x + (lineWidth * 2),
							y: beginPos.y + frameHeight
						}
					]
				]
				// 右上
				const rightTop = [
					[
						{
							x: beginPos.x + frameWidth,
							y: beginPos.y
						},
						{
							x: beginPos.x + frameWidth,
							y: beginPos.y + side
						}
					],
					[
						{
							x: beginPos.x + frameWidth + (lineWidth / 2),
							y: beginPos.y
						},
						{
							x: beginPos.x + frameWidth - (lineWidth * 2),
							y: beginPos.y
						}
					]
				]
				// 右下
				const rightBottom = [
					[
						{
							x: beginPos.x + frameWidth,
							y: beginPos.y + frameHeight
						},
						{
							x: beginPos.x + frameWidth,
							y: beginPos.y + frameHeight - side
						}
					],
					[
						{
							x: beginPos.x + frameWidth + (lineWidth / 2),
							y: beginPos.y + frameHeight
						},
						{
							x: beginPos.x + frameWidth - (lineWidth * 2),
							y: beginPos.y + frameHeight
						}
					]
				]
				const cornersArray = [leftTop, leftBottom, rightTop, rightBottom]
				cornersArray.forEach(corner => {
					for (let i = 0; corner.length > i; i++) {
						const posArray = []
						for (let n = 0; corner[i].length > n; n++) {
							posArray.push(corner[i][n])
						}
						// 横と縦の線を重ねて"「" のような形を描画
						if (posArray.length === 2) {
							drawLine(posArray[0], posArray[1])
						}
					}
				})
			}
		},
		...options
	})
	return instance
}

export const QuaggaPlugin = {
	install (Vue, options) {
		Vue.prototype.$quagga = useQuagga(options)
	}
}
